export default __webpack_public_path__ + "static/media/bground.73f42a06.jpg";